<div #scrollContainer class="row tax-planning-client new-input-fields" style="height: 60vh;overflow-y: scroll;">
  <div class="medium-6 columns">
    <label>
      First Name*
      <input type="text" [(ngModel)]="client.firstName" placeholder="First Name" (blur)="appendIndyRelatedParty()"/>
    </label>
  </div>
  <div class="medium-6 columns">
    <label>
      Last Name*
      <input type="text" [(ngModel)]="client.lastName" placeholder="Last Name" (blur)="appendIndyRelatedParty()"/>
    </label>
  </div>
  <div class="medium-6 columns">
    <label>
      Email*
      <input type="text" [(ngModel)]="client.email" placeholder="Email"/>
      <div class="error" *ngIf="client.email && !client.email.match('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$')">Please check email format</div>
    </label>
  </div>
  <div class="medium-6 columns">
    <label>
      Phone Number
      <input type="text" input-mask [(ngModel)]="client.phoneNumber" placeholder="Phone number"/>
      <!--      <div class="error" *ngIf="client.phoneNumber && !client.phoneNumber.match('^[0-9]{10}$')">Phone number should have 10 digits only</div>-->
    </label>
  </div>
  <div class="medium-6 columns">
    <label>
      Status
      <app-tpiq-select-dropdown [setData]="statusTypes" [includeNone]="false" (onValueSelect)="setClientStatus($event)"
                             [setDefaultValue]="client.status" [setSearchKey]="'name'" [setPlaceHolder]="'Status'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
    </label>
  </div>
  <div class="medium-12 columns mt-3">
    <label>
      Client Label(s)
      <div style="display: -webkit-box">
        <input type="text" style="width: 80%;margin-bottom: 0;" [(ngModel)]="tempLabelText" placeholder="Enter Label" (keydown.enter)="pushLabel()"/>
        <input class="add-label pointer" type="button" (click)="pushLabel()" value="Add" />
      </div>
    </label>
  </div>
  <div class="medium-12 columns" *ngIf="client.labels && client.labels.length > 0">
    <div class="row">
      <div class="medium-12 columns">
        <div class="small-12 medium-12 columns" style="margin-top: 10px">
          <div class="column small-12 medium-4 large-4" style="padding-left: 0px;float: left;margin-top: 3px" *ngFor="let label of client.labels;let i = index">
                  <span class="client-label">
                    <span>{{label.label}}</span>
                    <span class="pointer" (click)="removeLabel(i)" style="font-size: 10px;margin-left: 8px;">
                      <i class="icon ion-close-round" style="color: #444444;"></i>
                    </span>
                  </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="medium-12 columns row-margin">
    <label>
      Enable Client Portal
      <input style="margin-left: 10px;" type="checkbox" [(ngModel)]="client.enableClientPortal" [disabled]="currentPlan && currentPlan.toLowerCase().includes('basic')"/>
      <span style="margin-left: 30px; font-size: 12px; color: #f1645a" *ngIf="currentPlan && currentPlan.toLowerCase().includes('basic')">{{portalMessage}}</span>
    </label>
  </div>
  <div class="medium-12 columns row-margin" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;">
    <div class="row" style="padding-top: 5px" *ngFor="let relatedParty of client.relatedParties; let index = index;">
      <div class="medium-5 columns">
        <label>Related Party*
          <input type="text" [(ngModel)]="relatedParty.name" placeholder="Related Party"/>
        </label>
      </div>
      <div class="medium-5 columns">
        <label>Type
          <app-tpiq-select-dropdown [setData]="types" [includeNone]="false" (onValueSelect)="setType($event, relatedParty)"
                                 [setDefaultValue]="relatedParty.type" [setSearchKey]="'name'" [setPlaceHolder]="'Type'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
        </label>
      </div>
      <div class="medium-2 columns">
        <i style="position: relative;top: 25px;" class="material-icons delete-icon" (click)="removeRelatedParty(index)">delete</i>
      </div>
    </div>
    <div style="padding: 10px 0;">
            <span class="pointer badge-tooltip" (click)="addRelatedParty()">
              <i class="material-icons float-left add-icon">add_circle_outline</i>
              <span class="float-left add-text">Related Party</span>
              <span class="topTooltiptext related-parties-tooltip">
                Related parties can be any existing or potential businesses or related individuals to your client
              </span>
            </span>
    </div>
  </div>
</div>

<div class="row" style="margin-top: 20px;">
  <div class="medium-12">
    <button class="button small float-right" (click)="saveClient()">{{editMode? "Update": "Create"}}</button>
    <button class="button small float-right" style="border: 1px solid #D0D5DD;border-radius: 6px;background: #FFFFFF;color:#333333;" (click)="closeCreateOrUpdatePopup()">Cancel</button>
  </div>
</div>
